const SECTIONS_UPDATED = (state, sections) => {
  state.sections = sections
}

const TITLE_UPDATED = (state, title) => {
  state.title = title
}

const CURRENT_SECTION_UPDATED = (state, currentSection) => {
  state.currentSection = currentSection
}

const RESET = (state) => {
  state.currentSection = 0
  state.sections = []
}

export default {
  SECTIONS_UPDATED,
  TITLE_UPDATED,
  CURRENT_SECTION_UPDATED,
  RESET
}



// WEBPACK FOOTER //
// ./src/store/modules/sections/mutations.js